import { render, staticRenderFns } from "./vOperadores.vue?vue&type=template&id=383da3a0&scoped=true"
import script from "./vOperadores.vue?vue&type=script&lang=js"
export * from "./vOperadores.vue?vue&type=script&lang=js"
import style0 from "./vOperadores.vue?vue&type=style&index=0&id=383da3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383da3a0",
  null
  
)

export default component.exports